<div
    class="cmps-cdk-pb-0dot5"
    *ngFor="let i of items"
>
    <cmps-event-centre-card
        class="cmps-cdk-cursor-pointer"
        [expanded]="i.expanded"
        (click)="_onToggleExpandClick(i); _onToggleReadClick(i, true)"
        #card
    >
        <cmps-event-centre-card-stripe
            [class.cmps-cdk-bg-color-grey-400]="i.read"
            [style.background-color]="i.colour"
        >
            <cmps-icon [svgIcon]="i.icon"></cmps-icon>
        </cmps-event-centre-card-stripe>
        <cmps-event-centre-card-name>
            <cmps-icon
                svgIcon="account-circle"
                [class.cmps-cdk-fill-grey-400]="i.read"
                [style.color]="!i.read ? i.colour : ''"
            ></cmps-icon>
            <span cmpsEventCentreCardNameLabel>{{ i.title }}</span>
        </cmps-event-centre-card-name>
        <cmps-event-centre-card-message
            [class.cmps-cdk-bg-color-grey-200]="i.read"
        >
            <div cmpsEventCentreCardTarget>{{ i.name }}</div>
            <div
                class="cmps-cdk-color-grey-400 cmps-cdk-py-0dot25"
                [class.cmps-cdk-line-clamp-2]="!card.expanded"
            >
                {{ i.message }}
            </div>
            <div cmpsEventCentreCardTimestamp>
                {{ i.timestamp | cmpsDate: 'LLL dd y h:mm a' }}
            </div>
            <cmps-event-centre-card-actions
                [class.cmps-cdk-overflow-hidden]="!card.expanded"
            >
                <div cmpsEventCentreCardActionsLeft>
                    <ng-container *ngFor="let a of i.actions">
                        <button
                            class="cmps-cdk-bg-color-transparent"
                            cmpsCardIconButton
                            [cmpsTooltipTrigger]="a.name"
                            (click)="
                                $event.preventDefault();
                                $event.stopPropagation();
                                _onActionClick(i, a)
                            "
                        >
                            <cmps-icon
                                class="cmps-cdk-color-blue-100"
                                [svgIcon]="a.icon ?? 'help-circle-outline'"
                            ></cmps-icon>
                        </button>
                    </ng-container>
                </div>
                <div cmpsEventCentreCardActionsRight>
                    <button
                        cmpsCardIconButton
                        [cmpsTooltipTrigger]="
                            (!i.read
                                ? _i18n._11149_MARK_AS_READ
                                : _i18n._11150_MARK_AS_UNREAD
                            ) | translate
                        "
                        (click)="
                            $event.preventDefault();
                            $event.stopPropagation();
                            _onToggleReadClick(i)
                        "
                    >
                        <cmps-icon
                            [class.cmps-cdk-color-blue-100]="i.read"
                            [svgIcon]="
                                !i.read
                                    ? 'email-alert-outline'
                                    : 'email-check-outline'
                            "
                        ></cmps-icon>
                    </button>
                    <button
                        cmpsCardIconButton
                        [cmpsTooltipTrigger]="_i18n._7424_DELETE | translate"
                        (click)="
                            $event.preventDefault();
                            $event.stopPropagation();
                            _onDeleteClick(i)
                        "
                    >
                        <cmps-icon svgIcon="trash-can-outline"></cmps-icon>
                    </button>
                </div>
            </cmps-event-centre-card-actions>
        </cmps-event-centre-card-message>
    </cmps-event-centre-card>
</div>
